import Image from 'components/common/Image';
import { Box, Button, Card, CardBody, CardFooter, CardHeader, Text } from 'grommet';
import { stripMarkdown } from 'utils/stringUtils';
import { Location, Calendar, Money } from 'grommet-icons';
import React from "react";
import { useNavigate } from 'react-router-dom';
import { Course } from "types";

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1496094964281-6b2e28422c5c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80';

const formatShortDate = (dateStr: string) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short' });
};

const getNextDate = (dates: string[]): string | null => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const upcoming = dates
    .map(d => new Date(d))
    .filter(d => d >= today)
    .sort((a, b) => a.getTime() - b.getTime());
  return upcoming.length ? upcoming[0].toISOString() : dates[0] ?? null;
};

const CourseCard = ({ label, markdown, shortid, image, price, location, dates }: Course) => {
  const navigate = useNavigate();
  const plain = stripMarkdown(markdown);
  const description = plain.length > 90 ? `${plain.substring(0, 90)}…` : plain;
  const nextDate = getNextDate(dates);

  return (
    <Card
      width={{ min: '280px', max: '340px' }}
      background="white"
      style={{ boxShadow: '0 4px 20px rgb(0 0 0 / 18%)', borderRadius: '12px', overflow: 'hidden' }}
    >
      <CardHeader pad="none">
        <Image fit="cover" src={image || FALLBACK_IMAGE} style={{ height: '180px', width: '100%' }} />
      </CardHeader>
      <CardBody pad={{ horizontal: 'medium', top: 'medium', bottom: 'small' }} gap="small">
        <Text size="large" weight="bold" style={{ lineHeight: '1.3' }}>{label}</Text>
        <Text size="small" color="dark-4" style={{ lineHeight: '1.5' }}>{description}</Text>
        <Box gap="xsmall" margin={{ top: 'xsmall' }}>
          <Box direction="row" align="center" gap="xsmall">
            <Location size="small" color="brand" />
            <Text size="small">{location}</Text>
          </Box>
          {nextDate && (
            <Box direction="row" align="center" gap="xsmall">
              <Calendar size="small" color="brand" />
              <Text size="small">
                Neste: {formatShortDate(nextDate)}
                {dates.length > 1 && (
                  <Text size="small" color="dark-4"> · {dates.length} datoer</Text>
                )}
              </Text>
            </Box>
          )}
          <Box direction="row" align="center" gap="xsmall">
            <Money size="small" color="brand" />
            <Text size="small">{price} kr</Text>
          </Box>
        </Box>
      </CardBody>
      <CardFooter pad="medium">
        <Button
          hoverIndicator
          primary
          label="Vis kurs"
          onClick={() => navigate(`/kurs/${shortid}`)}
        />
      </CardFooter>
    </Card>
  );
};

export default CourseCard
